// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination[data-v-f1b2cf4c]{padding:.5rem 1rem;background-color:#fff}.pagination-next[data-v-f1b2cf4c]{border:none;justify-content:flex-start}@media only screen and (max-width:768px){.dropdown.is-right .dropdown-menu[data-v-f1b2cf4c]{right:unset}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
